/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class _class extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hidden: false
    };
    this.closeClicked = () => {
      this.setState({
        hidden: true
      });
    };
  }
  render() {
    if (this.state.hidden) {
      return null;
    }
    const {
      message
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "alert-message-container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "alert-message",
        children: [/*#__PURE__*/_jsx("span", {
          className: "icon icon-cancel",
          onClick: this.closeClicked
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message
        })]
      })
    });
  }
}
_class.propTypes = {
  message: PropTypes.string
};